<template>
  <div class="rightconover">
    <div class="contentwidth">
      <div class="noticebox">
        <div class="showbut">
          <lk-button img="print.png" style="margin-right: 20px">打印</lk-button>
          <lk-button img="back.png" type="lk_button_blue" @click="$emit('update:comName', 'Archives')">返回</lk-button>
        </div>
        <div class="noticebox_title">粮食质量档案</div>
        <table class="noticebox_table" border="1">
          <tr>
            <td>编号</td>
            <td>10002</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>仓房</td>
            <td>OP1</td>
            <td>仓房类型</td>
            <td></td>
          </tr>
          <tr>
            <td>粮食性质</td>
            <td>商品粮</td>
            <td>粮食权属</td>
            <td>浙粮集团</td>
          </tr>
          <tr>
            <td>粮食品种</td>
            <td>晚粳稻</td>
            <td>粮食等级</td>
            <td>国际三等</td>
          </tr>
          <tr>
            <td>产地</td>
            <td>东北</td>
            <td>入库时间</td>
            <td>2021-09-09</td>
          </tr>
          <tr>
            <td>总容量</td>
            <td>200（kg）</td>
            <td>当前仓容</td>
            <td>200（kg）</td>
          </tr>
          <tr>
            <td>检验结果</td>
            <td>合格</td>
            <td>检验时间</td>
            <td>2021-09-10</td>
          </tr>
          <tr class="bigtr">
            <td class="bigtd" colspan="4" style="height: 531px;">
              <div class="Notice_alert">
                <!--                <div class="table_title">-->
                <!--                  <div class="table_title_left">质检模板：晚粳稻入库国标质检</div>-->
                <!--                  <div class="table_title_right">检测标准：GB1350-2009</div>-->
                <!--                </div>-->
                <el-table border :data="alertNotice" style="width:100%">
                  <el-table-column prop="str1" label="质检类型" align="center" width="75"></el-table-column>
                  <el-table-column prop="str2" label="质检模板" align="center" width="130"></el-table-column>
                  <el-table-column prop="str3" label="检验标准" align="center" width="95"></el-table-column>
                  <el-table-column prop="str4" label="质检项" align="center" width="75"></el-table-column>
                  <el-table-column prop="str5" label="检测值" align="center" width="75"></el-table-column>
                  <el-table-column prop="str6" label="检测标准" align="center" width="75"></el-table-column>
                  <el-table-column prop="str7" label="检测结果" align="center" width="75"></el-table-column>
                  <el-table-column prop="str8" label="质检人" align="center" width="75"></el-table-column>
                  <el-table-column prop="str9" label="审核人" align="center" width="75"></el-table-column>
                  <el-table-column prop="str10" label="质检时间" align="center" width="75"></el-table-column>
                </el-table>
              </div>
            </td>
          </tr>
          <tr class="bigtr">
            <td class="bigtd" colspan="4" style="height: 186px;">
              <div class="Notice_alert">
                <div class="table_title">
                  <!--                  <div class="table_title_left">质检模板：晚粳稻入库国标质检</div>-->
                  <!--                  <div class="table_title_right">检测标准：GB1350-2009</div>-->
                  <div class="table_title_centre">满仓鉴定指标</div>
                </div>
                <div style="display: flex;margin: 0 auto;width: 70%;">
                  <el-table border :data="alertNotice1" style="flex: 1;">
                    <el-table-column prop="str1" label="质检项" align="center"></el-table-column>
                    <el-table-column prop="str2" label="判断标准" align="center"></el-table-column>
                  </el-table>
                  <el-table border :data="alertNotice2" style="flex: 1;">
                    <el-table-column prop="str1" label="质检项" align="center"></el-table-column>
                    <el-table-column prop="str2" label="判断标准" align="center"></el-table-column>
                  </el-table>
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td>仓管员</td>
            <td>张三</td>
            <td>联系电话</td>
            <td>1880650000</td>
          </tr>
          <tr class="bigtr">
            <td class="bigtd" colspan="4" style="height: 132px;">备注:</td>
          </tr>
        </table>
        <div class="noticebox_fotbox">
          <div class="fottitle_left">审核人:张三</div>
          <div class="fottitle_right">建档时间：2021-9-9</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LkButton from "@/components/manage/LkButton";
import { getName} from "@/utils/util";
export default {
  name: "ArchivesDetail",
  components: {LkButton},
  props: ['comName'],
  data() {
    return {
      // 1为默认 2为详情页面
      detailshow: 1,
      // 弹框展示相关 标题  显示的开关  弹框宽度  弹框数据
      showid: 0,
      showalert: false,
      showwidth: "676px",
      showdata: {},
      Detailshowid: 1,
      queryCheckNumber: '',//查找
      alertNotice: [
        {
          str1: "入库质检",
          str2: "晚粳稻入库国际检验",
          str3: "GB1350-2009",
          str4: "水分",
          str5: "1",
          str6: "≤1%",
          str7: "合格",
          str8: getName(),
          str9: getName(),
          str10: "2021-9-9"
        },
        {
          str1: "入库质检",
          str2: "晚粳稻入库国际检验",
          str3: "GB1350-2009",
          str4: "杂质",
          str5: "1",
          str6: "≤13.5%",
          str7: "合格",
          str8: getName(),
          str9: getName(),
          str10: "2021-9-9"
        },
        {
          str1: "秋季质检",
          str2: "晚粳稻入库国际检验",
          str3: "GB1350-2009",
          str4: "水分",
          str5: "1",
          str6: "≤1%",
          str7: "合格",
          str8: getName(),
          str9: getName(),
          str10: "2021-9-9"
        },
        {
          str1: "秋季质检",
          str2: "晚粳稻入库国际检验",
          str3: "GB1350-2009",
          str4: "杂质",
          str5: "1",
          str6: "≤13.5%",
          str7: "合格",
          str8: getName(),
          str9: getName(),
          str10: "2021-9-9"
        },
        {
          str1: "春季质检",
          str2: "晚粳稻入库国际检验",
          str3: "GB1350-2009",
          str4: "水分",
          str5: "1",
          str6: "≤1%",
          str7: "合格",
          str8: getName(),
          str9: getName(),
          str10: "2021-9-9"
        },
        {
          str1: "春季质检",
          str2: "晚粳稻入库国际检验",
          str3: "GB1350-2009",
          str4: "杂质",
          str5: "1",
          str6: "≤13.5%",
          str7: "合格",
          str8: getName(),
          str9: getName(),
          str10: "2021-9-9"
        },
      ],
      alertNotice1: [
        {
          str1: "水分",
          str2: "≤13.5%"
        },
        {
          str1: "杂质",
          str2: "≤1%"
        },
        {
          str1: "生霉粒",
          str2: "≤13.5%"
        },
        {
          str1: "粗糙率",
          str2: "≤1%"
        },
      ],
      alertNotice2: [
        {
          str1: "黄曲霉素",
          str2: "≤13.5%"
        },
        {
          str1: "铅",
          str2: "≤13.5%"
        },
        // {
        //   str1: "",
        //   str2: " "
        // },
        // {
        //   str1: " ",
        //   str2: " "
        // },
      ],
      Notice: [
        {
          str1: "10010",
          str2: "镇海库",
          str3: "op1",
          str4: "储备粮",
          str5: "国家",
          str6: "满仓质检",
          str7: "晚籼稻",
          str8: "东北",
          str9: "200",
          str10: "200",
          str11: "国际三等",
          str12: "合格",
          str13: "2010-09-10 10:00:00"
        }
      ],
      currentPage: 1,
      totalPage: 10,
      qualifiedList: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "库房1",
          label: "库房1",
        },
        {
          value: "库房2",
          label: "库房2",
        },
      ],
      qualifiedList1: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "小麦",
          label: "小麦",
        },
        {
          value: "晚籼稻",
          label: "晚籼稻",
        },
      ],
      qualifiedList2: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "张三",
          label: "张三",
        },
      ],
      qualifiedList3: [
        {
          value: null,
          label: "全部",
        },
        {
          value: "入库",
          label: "入库",
        },
        {
          value: "出库",
          label: "出库",
        }
      ],
      timepicker: "",
      qualified: "",
      qualified1: "",
      qualified2: "",
      qualified3: "",
      qualified4: "",
    };
  },
  methods: {
    ssssss(val) {
      console.log(val)
    },
    handleClick(val) {
      this.detailshow = 2;
      this.Detailshowid = val.str3;
      console.log(val);
    },
    alertShow(str, val, width) {
      console.log(str, val);
      this.showid = str;
      this.showwidth = width;
      this.showdata = val;
      this.showalert = true;
    },
    search() {
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(val);
      //   let json={column: "name",type: type.default.like, value: this.searchKey};
      //   json.value=this.searchKey;
      //   this.getdatalb(val,false,json)
    },
  },
};
</script>

<style scoped lang="scss">
.rightconover {
  height: 100%;
  background-color: #f5f6fa;
  overflow: auto;

  .contentwidth {
    width: 100%;

    .ContentMargin {
      box-sizing: border-box;
      margin: 30px 35px;
      background-color: #ffffff;
      box-shadow: 0 3px 5px 0 #d5dade;
      padding: 30px 40px;
    }
  }
}

::v-deep .el-dialog__body {
  padding: 0 20px;
}

.showbodymax {
  width: 100%;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #969696;

  .title {
    margin-bottom: 24px;
  }
}

.noticebox {
  width: 934px;
  margin: 32px auto;
  padding: 30px 40px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 3px 7px 0 rgba(91, 117, 148, 0.26);

  .noticebox_fotbox {
    width: 100%;
    margin-top: 30px;
    display: flex;
    font-size: 14px;
    font-family: PingFang SC, serif;
    font-weight: 500;
    color: #383838;

    .fottitle_left {
    }

    .fottitle_right {
      margin-left: auto;
    }
  }

  .noticebox_table {
    width: 100%;
    min-height: 25px;
    text-align: left;
    border-color: #DCDCDC;
    border-collapse: collapse;
    font-size: 14px;

    tr {
      td {
        padding: 15px;
        box-sizing: border-box;
        vertical-align: top;
      }

      td:nth-child(odd) {
        width: 90px;
        height: 40px;
      }

      td:nth-child(even) {
        width: 286px;
        height: 40px;
      }
    }

    .bigtr {
      .bigtd {
        width: 100%;
        height: 200px;

        .Notice_alert {
          -webkit-text-size-adjust: none;
          font-size: 9px;
          color: #969696;

          ::v-deep .el-table {
            -webkit-text-size-adjust: none;
            font-size: 9px;
          }

          ::v-deep .el-table th {
            background-color: #f4f7fd;
            color: #969696;
          }

          ::v-deep .el-table .el-table__cell {
            padding: 6px 0;
          }

          ::v-deep .el-table thead {
            color: #969696;
            -webkit-text-size-adjust: none;
            font-size: 9px;
          }
        }
      }
    }
  }

  .noticebox_title {
    width: 100%;
    text-align: center;
    font-size: 24px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #383838;
    margin-bottom: 30px;
  }

  .showbut {
    position: absolute;
    right: 36px;

    .el-button {
      padding: 10px 42px;
      font-size: 16px;
    }
  }
}

.table_title {
  display: flex;
  margin-bottom: 20px;

  .table_title_left {

  }

  .table_title_right {
    margin-left: auto;
  }

  .table_title_centre {
    flex: 1;
    text-align: center;
  }
}

.Notice_list {
  ::v-deep .el-table th {
    background-color: #f5f8ff;
  }

  ::v-deep .el-table thead {
    color: #000000;
  }
}

.showbody_padding {
  padding: 30px 0;
}

.showbody_bor {
  border-top: 1px solid #eeeeee;
}

.showbody {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #969696;

  .inputbox_marginr {
    margin-right: 5%;
  }

  .inputbox {
    width: 30%;
    margin-bottom: 14px;

    .title {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #969696;
      margin-bottom: 14px;
    }

    .input {
      width: 100%;
      height: 36px;
      line-height: 36px;
      overflow: auto;
      white-space: nowrap;
      box-sizing: border-box;
      padding-left: 10px;
      background: #f4f7fd;
      border: 1px solid #dcdcdc;
    }

    .input::-webkit-scrollbar {
      display: none;
    }
  }
}

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    max-width: 70%;
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    margin-left: auto;

    ::v-deep .el-button {
      padding: 10px 42px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      margin-bottom: 20px;

      ::v-deep .el-input-group__append {
        padding: 0 18px;
      }

      .el-button {
        padding: 10px;
      }
    }
  }
}

.paging {
  margin-top: 20px;

  ::v-deep .el-pagination {
    text-align: right;
  }
}
</style>
